<template>
  <!--
    interactive=true uses v-menu, which (unlike v-tooltip) keeps the popup
    open while the cursor is over the content — required when the popup
    contains a link or other clickable element the user needs to reach.
  -->
  <v-menu
    v-if="interactive"
    v-model="isOpen"
    :open-on-hover="true"
    :close-on-content-click="false"
    :open-delay="0"
    :close-delay="150"
    :content-class="tooltipClass"
    location="bottom"
    transition="fade-transition"
  >
    <template #activator="{ props: menuProps }">
      <slot name="activator" :props="menuProps">
        <v-icon v-bind="menuProps" size="16" style="color: #000; cursor: pointer"> mdi-information-outline </v-icon>
      </slot>
    </template>
    <div :style="contentStyleWithMaxWidth">
      <slot />
    </div>
  </v-menu>

  <v-tooltip v-else :max-width="tooltipMaxWidth" :content-class="tooltipClass">
    <template #activator="{ props: tooltipProps }">
      <slot name="activator" :props="tooltipProps">
        <v-icon v-bind="tooltipProps" size="16" style="color: #000"> mdi-information-outline </v-icon>
      </slot>
    </template>
    <div :style="contentStyle">
      <slot />
    </div>
  </v-tooltip>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InfoTooltip',

  props: {
    variant: {
      type: String,
      default: 'light',
      validator: (v) => ['light', 'dark'].includes(v)
    },
    maxWidth: {
      type: [Number, String],
      default: null
    },
    interactive: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpen: false
    };
  },

  computed: {
    tooltipMaxWidth() {
      if (this.maxWidth) return this.maxWidth;
      return this.variant === 'dark' ? 233 : 400;
    },
    tooltipClass() {
      return this.variant === 'dark' ? 'info-tooltip-dark' : 'info-tooltip';
    },
    contentStyle() {
      if (this.variant === 'dark') {
        return {
          padding: '10px',
          fontSize: '14px',
          lineHeight: '18px',
          color: '#ffffff'
        };
      }
      return {
        padding: '16px',
        fontSize: '14px',
        lineHeight: '1.5',
        color: '#666'
      };
    },
    contentStyleWithMaxWidth() {
      // v-menu doesn't expose a max-width prop, so apply it via style.
      return {
        ...this.contentStyle,
        maxWidth: `${this.tooltipMaxWidth}px`
      };
    }
  }
});
</script>

<style>
.info-tooltip {
  background-color: #f5f5f5 !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.info-tooltip .v-overlay__content {
  background-color: #f5f5f5 !important;
}

.info-tooltip-dark {
  background-color: #484848 !important;
  border: none !important;
  border-radius: 4px !important;
  padding: 0 !important;
}

.info-tooltip-dark .v-overlay__content {
  background-color: #484848 !important;
  padding: 0 !important;
}
</style>
